import { useQuery } from '@tanstack/react-query';
import { CongregationDto, fetchCongregations } from '~/generated';
import { extractData } from '~/utils/query-utils';

type UseCongregationsArgs = {
  page?: number;
  perPage?: number;
  searchTerm?: string;
  sortingExpressions?: string;
  circuitId?: number;
};

export const useCongregations = ({
  page = 0,
  perPage = 20,
  searchTerm,
  sortingExpressions,
  circuitId,
}: UseCongregationsArgs = {}) =>
  useQuery({
    queryKey: [
      'congregations',
      page,
      perPage,
      searchTerm,
      sortingExpressions,
      circuitId,
    ],
    queryFn: async () => {
      const response = await extractData(
        fetchCongregations({
          query: {
            PageNumber: page + 1,
            PageSize: perPage,
            ...(searchTerm && { SearchTerm: searchTerm }),
            ...(sortingExpressions && {
              SortingExpressions: sortingExpressions,
            }),
            ...(circuitId && { CircuitId: circuitId }),
          },
        })
      );

      return {
        data: (response.page?.items ?? []) as Array<
          CongregationDto & { id: number }
        >,
        totalCount: response.page?.totalItemCount ?? 0,
      };
    },
  });
